const isString = (value) => typeof value === "string";

export { isString };
